import Marquee from "react-fast-marquee";

const ITEMS = ["The Kindness Ball", "12.19.26", "Be Kind Community Inc", "1,000 Bears", "1,000,000 Pledges", "Red Carpet", "A Whole Vibe"];

export function MarqueeStrip() {
  return (
    <div className="border-y border-[#33240E]/15 py-5" data-testid="marquee-strip">
      <Marquee speed={35} gradient={false}>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif text-2xl italic text-[#33240E]/50">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#9E3C3C]/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
